/** @format */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './style/style.scss';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import { enableES5 } from 'immer';
import * as serviceWorker from 'src/serviceWorker';
import store from 'src/store';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import LoaderWrapper from 'src/utils/LoaderWrapper';
import { AuthProvider } from 'src/contexts/KeyCloakContext';
import SplashScreen from 'src/components/SplashScreen';
import App from 'src/App';
import i18n from './i18n';

import { trackDataLayer } from './utils/dataLayer';
window.trackDataLayer = trackDataLayer;

ReactDOM.render(
  <Suspense fallback={<SplashScreen />}>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </Suspense>,
  document.getElementById('root')
);

serviceWorker.register();
document.getElementsByTagName('html')[0].setAttribute('lang', i18n.language || 'en');
